(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('ext', {
                abstract: true,
                resolve: {
                    availableDates: ['YieldCurveResultsOpen', function (YieldCurveResultsOpen) {
                        return YieldCurveResultsOpen.query({datesOnly: ""}, function (res) {
                            return res.sort();
                        }).$promise;
                    }],
                    thresholdDate: ['AppDatesOpen', function (AppDatesOpen) {
                        return AppDatesOpen('old-curve-threshold').query().$promise;
                    }]
                }
            })
            .state('en', {
                parent: 'ext',
                url: '/ext/en',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/ext/ext-en.html',
                        controller: 'ExtController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('ro', {
                parent: 'ext',
                url: '/ext/ro',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/ext/ext-ro.html',
                        controller: 'ExtController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('ru', {
                parent: 'ext',
                url: '/ext/ru',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/ext/ext-ru.html',
                        controller: 'ExtController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();
